import { authService } from "../utils/authService";
import { errorHandler } from "../components/shared/errorhandler";
import { IBasicApiResponse, ISessionConfig } from "./App.interface";

export const checkResourceExistence = async (): Promise<IBasicApiResponse> => {
  // Local resources always exist — no SPC dependency
  return Promise.resolve({ isSuccessful: true, message: "OK" });
};

export const getInstanceSessionDefault = async (): Promise<ISessionConfig> => {
  return fetch("/api/v1/instance/session-defaults", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};
